import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import UpdateTankForm from '@/components/pages/Tanks/Update/Form'
import UpdateTankPageHeader from '@/components/pages/Tanks/Update/PageHeader'
import routes from '@/constants/routes'
import { useDetergents } from '@/pages/Detergents/Detergent.hooks'
import { UpdateTankRequest } from '@/types/apis/tanks/updateTankRequest'

import { useGetTank, useUpdateTanks } from './Update.hooks'

const UpdateTank = () => {
  const params = useParams<{ id: string }>()

  const tankId = Number(params.id)

  const navigate = useNavigate()

  const { updateTank, loading } = useUpdateTanks()
  const { getTank, response, loading: getLoading } = useGetTank()
  const { getAllDetergent, detergents } = useDetergents()

  const handleSubmitForm = async (formValues: UpdateTankRequest) => {
    await updateTank({
      ...formValues,
      id: tankId,
      detergentIds: Array.isArray(formValues.detergentIds) ? formValues.detergentIds : [formValues.detergentIds],
    })

    navigate(routes.tanks.path)
  }

  useEffect(() => {
    if (tankId) {
      getAllDetergent()
      getTank({ id: tankId })
    }
  }, [getAllDetergent, getTank, tankId])

  return (
    <>
      <UpdateTankPageHeader />
      <UpdateTankForm
        {...{ updateLoading: loading, getLoading, getTankResponse: response, detergents }}
        onSubmit={handleSubmitForm}
      />
    </>
  )
}

UpdateTank.displayName = 'UpdateTank'
export default UpdateTank
